<template>
  <div class="h5-container">
    <header class="h5-header">{{ test_report_project_name }}测试报告</header>
    <main class="h5-main">
      <div class="userinfo-box flex">
        <div class="avatar-box">
          <img class="avatar-icon" :src="student_info.avatar" alt="" />
          <img class="sex-icon" :src="sexImgList[student_info.gender]" alt="" />
        </div>
        <div class="center-content">
          <span class="user-name">{{ student_info.name }}</span>
          <div>
            <span>班级</span>
            <span>{{ student_info.class_title }}</span>
          </div>
          <div>
            <span>学号</span>
            <span>{{ student_info.student_number }}</span>
          </div>
        </div>
        <div class="right-content flex">
          <p>测试成绩</p>
          <div>
            <span>{{ test_result_info.number }}</span>
            <span>{{ test_result_info.unit }}</span>
          </div>
        </div>
      </div>
      <div class="achievement-box flex">
        <div class="detail-item">
          <img src="@/assets/imgs/score_icon.png" alt="" />
          <div>
            <span>{{ test_result_info.score }}</span>
            <span>分数</span>
          </div>
        </div>
        <div class="detail-item">
          <img src="@/assets/imgs/level_icon.png" alt="" />
          <div>
            <span>{{ test_result_info.level }}</span>
            <span>等级</span>
          </div>
        </div>
        <div class="detail-item">
          <img src="@/assets/imgs/grade_icon.png" alt="" />
          <div>
            <span>{{ test_result_info.grade_rank }}</span>
            <span>年级排名</span>
          </div>
        </div>
        <div class="detail-item">
          <img src="@/assets/imgs/class_icon.png" alt="" />
          <div>
            <span>{{ test_result_info.class_rank }}</span>
            <span>班级排名</span>
          </div>
        </div>
      </div>
      <div class="parameter-box flex">
        <div
          class="parmas-item"
          v-for="(item, index) in test_report_parameters"
          :key="index"
        >
          <span>{{ item.name }}</span>
          <span>{{ item.value }}</span>
        </div>
      </div>

      <!-- 运动曲线 -->
      <div class="echart-box" v-if="test_report_chart_data.length != 0">
        <div class="top-box">
          <div class="title-box">
            <img src="@/assets/imgs/sport_echart_icon.png" alt="" />
            <span>运动曲线</span>
          </div>
          <div class="tags-box" v-if="test_report_project_name != '跳绳'">
            <div>
              <span class="tag-icon tag-icon-good"></span>
              <span>上升时间</span>
            </div>
            <div>
              <span class="tag-icon tag-icon-bad"></span>
              <span>下降时间</span>
            </div>
          </div>
        </div>
        <div class="canvas-box" id="echarts-line-h5" />
      </div>

      <!-- 测试点评 -->
      <div class="comment-box">
        <div class="title-box">
          <img src="@/assets/imgs/test_comment_icon.png" alt="" />
          <span>测试点评</span>
        </div>
        <div class="content-box">
          <div class="comment-good flex" v-if="test_report_comment[0]">
            <div class="left">
              <img src="@/assets/imgs/comment_good_icon.png" alt="" />
              <span>做的很棒!</span>
            </div>
            <p class="wrap-text">{{ test_report_comment[0] }}</p>
          </div>
          <div class="comment-bad flex" v-if="test_report_comment[1]">
            <div class="left">
              <img src="@/assets/imgs/comment_bad_icon.png" alt="" />
              <span>有待提高!</span>
            </div>
            <p class="wrap-text">{{ test_report_comment[1] }}</p>
          </div>
        </div>
      </div>

      <div class="muscle-box">
        <div class="title-box">
          <img src="@/assets/imgs/muscle_icon.png" alt="" />
          <span>肌群状态</span>
        </div>
        <div class="tags-box">
          <div>
            <span class="tag-icon tag-icon-good"></span>
            <span>状态良好</span>
          </div>
          <div>
            <span class="tag-icon tag-icon-bad"></span>
            <span>有待加强</span>
          </div>
        </div>
        <div class="content-box">
          <div class="img-box">
            <img :src="test_report_muscles.muscles_img_src" alt="" />
          </div>
          <p class="wrap-text">{{ test_report_muscles.comment }}</p>
        </div>
      </div>

      <!-- 截图模块 -->
      <div class="screenshot-box flex">
        <div
          class="screenshot-item"
          v-for="(item, index) in test_report_screenshots"
          :key="index"
          @click="clickScreenshot(index + 1)"
        >
          <img :src="item.value" alt="" />
          <div class="screenshot-tag">
            <p>{{ item.name }}</p>
          </div>
        </div>
      </div>
    </main>
    <div class="mask-box" @click="closeDialog" v-if="showDialog" @touchmove.stop.prevent>
      <div class="el-sport-screenshot flex">
        <swiper ref="elSwiper" :options="dialogSwiperOptions" class="el-screenshot-box">
          <swiper-slide v-for="(item, index) in test_report_screenshots" :key="index">
            <img :src="item.value" alt="" />
            <div class="el-screenshot-tag">
              <span>{{ item.name }}</span>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.min.css";
export default {
  name: "",
  components: { swiper, swiperSlide },
  props: ["reportData"],
  data() {
    return {
      sexImgList: [
        "",
        require("@/assets/imgs/sex_boy.png"),
        require("@/assets/imgs/sex_girl.png"),
      ],
      test_report_project_name: "",
      student_info: {},
      test_report_chart_data: [],
      test_report_comment: [],
      test_report_muscles: {},
      test_report_parameters: [],
      test_report_screenshots: [],
      test_result_info: {},

      echart_sports_line_canvas: "",
      echart_sports_line_one_color: [
        "rgba(0,126,255,1)",
        "rgba(0,126,255,.3)",
        "rgba(0,126,255,.1)",
      ],
      echart_sports_line_two_color: [
        "rgba(255,211,67,1)",
        "rgba(255,211,67,.3)",
        "rgba(255,211,67,.1)",
      ],
      xAxisUnit: "个", //项目为跳绳时  s
      yAxisUnit: "s", //项目为跳绳时  个

      showDialog: false,
      //弹窗的轮播
      dialogSwiperOptions: {
        autoplay: false,
        loop: true,
      },
    };
  },
  mounted() {},
  methods: {
    clickScreenshot(index) {
      this.showDialog = true;

      console.log(index);
      this.$nextTick(() => {
        this.$refs.elSwiper.swiper.slideTo(index, 300, true);
      });
    },
    closeDialog() {
      this.showDialog = false;
    },

    getReportData() {
      this.test_report_project_name = this.reportData.test_report_project_name;
      this.student_info = this.reportData.student_info;
      this.test_report_chart_data = this.reportData.test_report_chart_data;
      this.test_report_comment = this.reportData.test_report_comment;
      this.test_report_muscles = this.reportData.test_report_muscles;
      this.test_report_parameters = this.reportData.test_report_parameters;
      this.test_report_screenshots = this.reportData.test_report_screenshots;
      this.test_result_info = this.reportData.test_result_info;

      this.$nextTick(() => {
        this.setDocumentTitle();
        this.echart_sports_line();
      });
    },

    setDocumentTitle() {
      var title = this.student_info.name + "的测试报告";
      document.title = title;
    },

    // 各项目运动占比
    echart_sports_line() {
      var test_report_project_name = this.test_report_project_name;
      this.echart_sports_line_canvas = echarts.init(
        document.getElementById("echarts-line-h5")
      );
      const xAxisData = [];
      for (let i = 0; i < this.test_report_chart_data[0].length; i++) {
        if (test_report_project_name == "跳绳") {
          xAxisData.push(i * 5);
        } else {
          xAxisData.push(i);
        }
      }
      var option;
      option = {
        tooltip: {
          trigger: "axis",
          formatter(params) {
            if (params.length == 1) {
              return `<div>第${params[0].axisValueLabel}秒</div>
                  <div>${params[0].marker}跳绳个数：${params[0].data}个</div>`;
            }
            if (params.length == 2) {
              return `<div>第${params[0].axisValueLabel}个</div>
                  <div>${params[0].marker}上升时间：${params[0].data}秒</div>
                  <div>${params[1].marker}下降时间：${params[1].data}秒</div>`;
            }
          },
        },
        grid: {
          top: 40,
          bottom: 40,
          left: 30,
          right: 30,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          //刻度
          axisTick: {
            show: false,
          },
          //grid区域分割线
          splitLine: {
            show: true,
          },
          data: xAxisData,
          name: this.test_report_project_name == "跳绳" ? this.yAxisUnit : this.xAxisUnit,
        },
        yAxis: {
          type: "value",
          //grid区域分割线
          splitLine: {
            show: false,
          },
          name: this.test_report_project_name == "跳绳" ? this.xAxisUnit : this.yAxisUnit,
          nameTextStyle: {
            align: "right",
          },
          axisLine: {
            show: true,
          },
        },
        series: [
          {
            itemStyle: {
              color: this.echart_sports_line_one_color[0],
            },
            data: this.test_report_chart_data[0],
            type: "line",
            symbol: "circle",
            symbolSize: 10,
            areaStyle: {
              opacity: 1,
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: this.echart_sports_line_one_color[0], // 0% 处的颜色
                  },
                  {
                    offset: 0.7,
                    color: this.echart_sports_line_one_color[1], // 70% 处的颜色
                  },
                  {
                    offset: 1,
                    color: this.echart_sports_line_one_color[2], // 100% 处的颜色
                  },
                ],
              },
            },
          },
          {
            itemStyle: {
              color: this.echart_sports_line_two_color[0],
            },
            data: this.test_report_chart_data[1] ? this.test_report_chart_data[1] : [],
            type: "line",
            symbol: "circle",
            symbolSize: 10,
            areaStyle: {
              opacity: 1,
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: this.echart_sports_line_two_color[0], // 0% 处的颜色
                  },
                  {
                    offset: 0.7,
                    color: this.echart_sports_line_two_color[1], // 70% 处的颜色
                  },
                  {
                    offset: 1,
                    color: this.echart_sports_line_two_color[2], // 100% 处的颜色
                  },
                ],
              },
            },
          },
        ],
      };
      option && this.echart_sports_line_canvas.setOption(option);
    },
  },
};
</script>

<style lang="less" scoped>
.h5-container {
  width: 100%;
  height: 100%;
  color: #100f48;
}
.h5-header {
  width: 100%;
  height: 56px;
  line-height: 56px;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  color: #333333;
  box-shadow: 0px 0px 2px 1px #e5e9f2;
}
.h5-main {
  width: 100%;
  padding: 12px 16px;
  background: #f5f6fa;
}
.userinfo-box {
  width: 100%;
  height: 88px;
  background: #ffffff;
  box-shadow: 0px 1px 4px 1px #e5e9f2;
  border-radius: 6px;
  padding: 16px 8px;
  .avatar-box {
    position: relative;
    width: 56px;
    height: 56px;
    margin-right: 16px;
    .avatar-icon {
      position: absolute;
      width: 56px;
      height: 56px;
      border-radius: 50%;
    }
    .sex-icon {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 14px;
      height: 14px;
    }
  }

  .center-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .user-name {
      font-size: 16px;
      font-weight: bold;
    }
    div {
      display: flex;
      align-items: center;
      span:nth-child(1) {
        font-size: 12px;
        font-weight: bold;
        margin-right: 20px;
      }
      span {
        font-size: 12px;
      }
    }
  }

  .right-content {
    margin-left: auto;
    flex-direction: column;
    align-items: center;
    font-weight: bold;
    p {
      font-size: 14px;
    }
    div {
      span:nth-child(1) {
        font-size: 24px;
      }
      span:nth-child(2) {
        font-size: 14px;
      }
    }
  }
}
.achievement-box {
  width: 100%;
  height: 56px;
  margin: 8px 0;
  border-radius: 6px;
  background: linear-gradient(180deg, #679cf6 0%, #4072ee 100%);
  .detail-item {
    flex: 1;
    display: flex;
    align-items: center;
    height: 56px;
    padding-left: 8px;
    img {
      width: 24px;
      height: 24px;
    }
    div {
      width: 100%;
      display: flex;
      flex-direction: column;
      color: #ffffff;
      text-align: center;
      span:nth-child(1) {
        font-size: 14px;
        font-weight: bold;
      }
      span:nth-child(2) {
        font-size: 10px;
      }
    }
  }
}
.parameter-box {
  width: 100%;
  flex-wrap: wrap;
  .parmas-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 25%;
    height: 68px;
    border-radius: 6px;
    background: #ffffff;
    border-right: 2px solid #f5f6fa;
    border-bottom: 2px solid #f5f6fa;
    span:nth-child(1) {
      font-size: 12px;
      margin-top: 3px;
    }
    span:nth-child(2) {
      font-size: 16px;
      margin-top: 13px;
    }
  }
  .parmas-item:nth-child(4n) {
    border: none;
  }
}

.echart-box {
  width: 100%;
  height: 216px;
  background: #ffffff;
  box-shadow: 0px 1px 4px 1px #e5e9f2;
  border-radius: 6px;
  margin-top: 6px;
  padding: 8px;
  .top-box {
    display: flex;
    justify-content: space-between;
    .tags-box {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      width: 160px;
      height: 22px;
      background: linear-gradient(180deg, #679cf6 0%, #4072ee 100%);
      border-radius: 6px;
      font-size: 12px;
      color: #ffffff;
      div {
        display: flex;
        align-items: center;
        .tag-icon {
          width: 8px;
          height: 8px;
          border-radius: 8px;
          margin-right: 6px;
        }
        .tag-icon-good {
          background: #22e1ff;
        }
        .tag-icon-bad {
          background: #ffd343;
        }
      }
    }
  }
  .canvas-box {
    width: 100%;
    height: 100%;
  }
}
.comment-box {
  width: 100%;
  background: #ffffff;
  box-shadow: 0px 1px 4px 1px #e5e9f2;
  border-radius: 6px;
  margin-top: 8px;
  padding: 8px;
  .content-box {
    margin-top: 12px;
    .comment-bad {
      margin-top: 16px;
    }
    .left {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 18px;
      img {
        width: 32px;
        height: 32px;
      }
      span {
        font-size: 12px;
        color: #f09636;
        white-space: nowrap;
      }
    }
  }
}

.muscle-box {
  width: 100%;
  background: #ffffff;
  box-shadow: 0px 1px 4px 1px #e5e9f2;
  border-radius: 6px;
  margin-top: 8px;
  padding: 8px;
  .tags-box {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    width: 100%;
    height: 24px;
    margin-top: 8px;
    background: linear-gradient(180deg, #679cf6 0%, #4072ee 100%);
    border-radius: 6px;
    font-size: 12px;
    color: #ffffff;
    div {
      display: flex;
      align-items: center;
      .tag-icon {
        width: 8px;
        height: 8px;
        border-radius: 8px;
        margin-right: 8px;
      }
      .tag-icon-good {
        background: #fa8b25;
      }
      .tag-icon-bad {
        background: #85cff9;
      }
    }
  }
  .img-box {
    width: 100%;
    padding: 20px 18px;
    margin-top: 8px;
    margin-bottom: 8px;
    background: #f4f5fe;
    border-radius: 6px;
    opacity: 0.69;
    img {
      width: 100%;
    }
  }
}

.screenshot-box {
  width: 100%;
  margin-top: 8px;
  justify-content: space-between;
  flex-wrap: wrap;
  .screenshot-item {
    position: relative;
    width: 160px;
    height: 105px;
    border: 1px solid #4072ee;
    margin-bottom: 8px;
    box-sizing: border-box;
    overflow: hidden;
    vertical-align: bottom;
    img {
      display: block;

      width: 160px;
      height: 105px;
    }
    .screenshot-tag {
      position: absolute;
      left: 0;
      bottom: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 90px;
      height: 30px;
      background: #4072ee;
      border-radius: 0 4px 0 0;
      color: #ffffff;

      p {
        display: inline-block;
        height: 30px;
        line-height: 30px;
        font-size: 10px;
        color: #ffffff;
        white-space: nowrap;
      }
    }
  }
}

.mask-box {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2000;
  width: 100%;
  height: 100%;
  background: #000;
}

.el-sport-screenshot {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  .el-screenshot-box {
    width: 100%;
    .swiper-slide {
      position: relative;
      img {
        width: 100%;
        height: 100%;
      }
      .el-screenshot-tag {
        position: absolute;
        left: 0;
        top: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 90px;
        height: 30px;
        background: #4072ee;
        border-radius: 0 0 4px 0;
        color: #ffffff;
        span {
          display: inline-block;
          height: 30px;
          line-height: 30px;
          font-size: 10px;
          color: #ffffff;
          white-space: nowrap;
        }
      }
    }
  }
}

.wrap-text {
  font-size: 12px;
  white-space: pre-wrap;
  line-height: 16px;
}

.title-box {
  display: flex;
  align-items: center;
  img {
    width: 16px;
    height: 16px;
    margin-right: 4px;
  }
  span {
    font-size: 16px;
    font-weight: bold;
  }
}
</style>
